import { fetchPDF } from '../../services/QuotationServices';
import { printSalesOrder } from '../../services/SalesOrderServices';
import { printJobCompletion } from '../../services/WorkScheduleServices';
import { printDeliveryChallan } from '../../services/DeliveryChallanServices';

export const CUSTOMER_SITE_DETAIL_ACTIONS = {
  quotation: {
    printTitle: 'Quotation',
    printFileName: 'quotation.pdf',
    print: (cookies, id) => fetchPDF(cookies, id),
  },
  order: {
    printTitle: 'Sales Order',
    printFileName: 'salesorder.pdf',
    print: (cookies, id) => printSalesOrder(cookies, id),
  },
  schedule: {
    printTitle: 'Job Completion',
    printFileName: 'job_completion.pdf',
    print: (cookies, id) => printJobCompletion(cookies, id),
  },
  dc: {
    printTitle: 'Delivery Challan',
    printFileName: 'delivery_challan.pdf',
    print: (cookies, id) => printDeliveryChallan(cookies, id),
  },
};
